/* src/app/components/controls/proXSign/pxs-base/pxs-base.component.css */
/*# sourceMappingURL=pxs-base.component.css.map */
